<template>
	<!-- 头部 header 组件-->
	<div class="headerTop" :style="{backgroundImage:newBackground}">
		<div class="headerContent">
			<!-- 左侧协会logo -->
			<div class="headerLogo">
				<img :src="bannerLogo" style="width: 100%;height: 100%;" alt="">
			</div>
			<!-- 右侧时间 + 搜索 -->
			<div class="">
				<div class="headerTime">
					<p>{{newTime}}</p>
				</div>
				<div class="headerSearch">
					<input type="text" v-model="searchInput" @keydown.enter="searchInfo" placeholder="搜索你想了解的政策/资讯/服务">
					<div class="searchBtn" @click="searchInfo">
						<img src="../assets/img/main/search.png" alt="" srcset="">
						<p>搜索</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				newTime: '',
				newBackground: '',
				bannerLogo: '',
				searchInput:''
			}
		},
		props: {
			banner: {
				type: Object,
				default: () => {}
			},
			bannerlogo: {
				type: String,
				default: ''
			},
			isfirst:{
				type:Boolean,
				default:false
			}
		},
		watch: {
			banner(newValue) {
				this.newBackground = `url('${newValue.path}')`
			},
			bannerlogo(newValue) {
				this.bannerLogo = newValue
			}
		},
		created() {
			this.setDateTime()
			setInterval(() => {
				this.setDateTime()
			}, 1000)
		},
		methods: {
			// 设置时间
			setDateTime() {
				let date = new Date() // 年 
				let ynum = date.getFullYear() // 月
				let mnum = date.getMonth() // 天 
				let dnum = date.getDate() // 星期几 
				let xnum = date.getDay() // 小时 
				let hournum = date.getHours() // 分 
				let minnum = date.getMinutes() // 秒 
				let snum = date.getSeconds() // 转换星期几 
				let week = "";
				switch (xnum) {
					case 0:
						week = "星期天";
						break;
					case 1:
						week = "星期一";
						break;
					case 2:
						week = "星期二";
						break;
					case 3:
						week = "星期三";
						break;
					case 4:
						week = "星期四";
						break;
					case 5:
						week = "星期五";
						break;
					case 6:
						week = "星期六";
						break;
				}
				this.newTime =
					`${ynum}年${mnum+1}月${dnum}日 ${week}${hournum<10?'0'+hournum:hournum}:${minnum<10?'0'+minnum:minnum}:${snum<10?'0'+snum:snum}`
			},
			searchInfo() {
				if (!this.searchInput) {
					this.$message({
						message: '请先输入查询内容',
						type: 'warning'
					});
					return
				}
				if(this.isfirst){
					const url =  './pages/searchInfo.html'+ '?search=' + this.searchInput
					window.open(url,'_self')
				}else{
					const url =  './searchInfo.html'+ '?search=' + this.searchInput
					window.open(url,'_self')
				}
			},
		}
	}
</script>

<style scoped>
	/* 头部组件 */
	.headerTop {
		width: 100%;
		height: 200px;
		background-size: cover;
	}

	.headerContent {
		width: 1200px;
		margin-left: auto;
		margin-right: auto;
		display: flex;
		padding-top: 50px;
		justify-content: space-between;
	}

	.headerLogo {
		width: calc(100% - 369px);
		height: 140px;
		margin-right: 10px;
	}

	.headerSearch {
		margin-top: 16px;
		width: 315px;
		height: 45px;
		background: #FFFFFF;
		box-shadow: 0px 0px 8px 0px rgba(24, 56, 90, 0.2700);
		border-radius: 4px;
		display: flex;
		cursor: pointer;
	}

	.headerSearch input {
		width: 233px;
		border-radius: 4px 0 0 4px;
		padding-left: 16px;
	}

	.searchBtn {
		width: 110px;
		height: 45px;
		background: #125DB2;
		box-shadow: 0px 0px 8px 0px rgba(24, 56, 90, 0.2700);
		border-radius: 0px 4px 4px 0px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.searchBtn img {
		width: 17px;
		height: 17px;
	}

	.searchBtn p {
		margin-left: 10px;
		width: 40px;
		height: 28px;
		font-size: 20px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
		line-height: 28px;
		text-shadow: 0px 0px 8px rgba(24, 56, 90, 0.2700);
	}

	.headerTime p {
		margin-top: 23px;
		text-align: center;
		font-size: 20px;
		font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
		font-weight: bold;
		color: #125DB2;
	}

	input[placeholder],
	[placeholder],
	*[placeholder] {
		color: #666;
		font-size: 14px;
	}

	input::input-placeholder {
		color: #666;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #666666;
		line-height: 20px;
		text-shadow: 0px 0px 8px rgba(24, 56, 90, 0.2700);
	}

	input::-webkit-input-placeholder {
		/* WebKit browsers */
		color: #666;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #666666;
		line-height: 20px;
		text-shadow: 0px 0px 8px rgba(24, 56, 90, 0.2700);
	}

	input::-moz-placeholder {
		/* Mozilla Firefox 19+ */
		color: #666;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #666666;
		line-height: 20px;
		text-shadow: 0px 0px 8px rgba(24, 56, 90, 0.2700);
	}

	input::-ms-input-placeholder {
		/* Internet Explorer 10+ */
		color: #666;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #666666;
		line-height: 20px;
		text-shadow: 0px 0px 8px rgba(24, 56, 90, 0.2700);
	}
</style>
